export const closeMiniMap = (device_id) => ({
    type: 'CLOSE_MINI_MAP',
    device_id,
});
export const openMiniMap = (device_id) => ({
    type: 'OPEN_MINI_MAP',
    device_id,
});
export const closeAboutMIniMap = () => ({
    type: 'CLOSE_ABOUT_MINI_MAP',
});
